export const TRAINING_PROGRAM_AGENT_FEATURE_FLAG = "training_program_agent_feature";
